/**
 * PARA BİRİMİ SEÇİCİ — deftere yeni kod girmenin TEK yolu.
 *
 * Niçin serbest metin değil: "TL" yazıldığında sistem onu sessizce kabul
 * etti, kur hiçbir zaman bulunamadı ve rapor maliyeti `null` verdi. Kullanıcı
 * ekranda "—" gördü, sebebi ancak defter elle düzeltilerek anlaşıldı.
 * Yazılabilen her kod, bir gün yanlış yazılacak koddur.
 *
 * TANINMAYAN ESKİ DEĞER SESSİZCE DEĞİŞTİRİLMEZ. Eski bir kayıt düzenlemek
 * için açıldığında `value` listede olmayabilir ("TL"). Seçici o durumda onu
 * listenin başına AYRI bir seçenek olarak koyar ve "tanınmıyor" diye
 * işaretler. Alternatifi — listede yok diye TRY'ye düşmek — kullanıcının
 * kaydını o kayıt kaydedilirken habersizce değiştirmek olurdu; bir kaydı
 * sessizce değiştirmek, yanlış kaydı ekranda göstermekten beterdir.
 */

import { CURRENCIES, isKnownCurrency } from "@parafon/contracts";
import { M } from "../dil";
import { paraBirimiAdi } from "../lib/format";
import { Select } from "./primitives";

export interface CurrencySelectProps {
  readonly id: string;
  readonly value: string;
  readonly onChange: (code: string) => void;
  readonly invalid?: boolean;
  readonly className?: string;
}

/** Listede olmayan bir kod seçiliyse gösterilecek etiket. */
export function unknownCurrencyLabel(code: string): string {
  return M.ui.paraBirimiTaninmiyor(code);
}

export function CurrencySelect({ id, value, onChange, invalid, className }: CurrencySelectProps) {
  const known = CURRENCIES.map((c) => ({ value: c.code, label: `${c.code} — ${paraBirimiAdi(c.code)}` }));
  const trimmed = value.trim().toUpperCase();
  // Boş değer de listede değildir ama "tanınmıyor" DEĞİLDİR: henüz seçilmemiş
  // demektir ve yer tutucuyla söylenir.
  const stray = trimmed !== "" && !isKnownCurrency(trimmed);
  const options = stray ? [{ value: trimmed, label: unknownCurrencyLabel(trimmed) }, ...known] : known;

  return (
    <Select
      id={id}
      className={className}
      options={options}
      {...(trimmed === "" ? { placeholder: M.ortak.secin } : {})}
      value={trimmed}
      aria-invalid={invalid === true}
      onChange={(e) => onChange(e.currentTarget.value)}
    />
  );
}
